import { Typography } from "@mui/material";
import React from "react";
import Success from "../Common/Success";
import { CustomMessageToast } from "../CustomMessageToast/CustomMessageToast";
import ChatComponent from "../HelpInteraction/ChatComponent";
//import PreventiveMeasures from "./PreventiveMeasures";
import chatList from "../HelpInteraction/chatList.json";
import CheckForFaultBoxComponents from "../HelpInteraction/CheckForFaultsBoxComponent";
import CheckingForFaultsComponent from "../HelpInteraction/CheckingForFaultsComponent";
import FixOrRestoreActionBox from "../HelpInteraction/FixOrRestoreActionBox";

export interface ICheckFaultsFlow {
  MRIisFixed: () => void;
  scenario4Finish: () => void;
}

const CheckFaultsFlow = ({ MRIisFixed, scenario4Finish }: ICheckFaultsFlow) => {
  const [nextSlide, showNextSlide] = React.useState(1);
  const displayNextSlide = () => {
    showNextSlide(nextSlide + 1);
  };

  return nextSlide === 1 ? (
    <>
      <FixOrRestoreActionBox displayNextSlide={displayNextSlide} />
    </>
  ) : nextSlide === 2 ? (
    <>
      <ChatComponent
        chatList={chatList[10]}
        displayNextSlide={displayNextSlide}
      />
    </>
  ) : nextSlide === 3 ? (
    <>
      <CheckForFaultBoxComponents displayNextSlide={displayNextSlide} />
    </>
  ) : nextSlide === 4 ? (
    <>
      <CheckingForFaultsComponent displayNextSlide={displayNextSlide} />
    </>
  ) : nextSlide === 5 ? (
    <>
      {MRIisFixed()}
      <Success
        displayNextSlide={displayNextSlide}
        message1={"Successfully completed"}
        message2={"No further faults"}
      />
      <ChatComponent
        chatList={chatList[12]}
        displayNextSlide={displayNextSlide}
      />
    </>
  ) : nextSlide === 6 ? (
    <>
      <ChatComponent
        chatList={chatList[11]}
        displayNextSlide={displayNextSlide}
      />
    </>
  ) : nextSlide === 7 ? (
    <>
      <CustomMessageToast
        open={true}
        customMessage={"Please got to 'Server room'"}
      />
      {scenario4Finish()}
    </>
  ) : (
    <Typography
      variant="h4"
      sx={{
        fontWeight: "700",
        paddingLeft: "4rem",
        color: "rgba(67, 91, 110, 0.8)",
      }}
    >
      Something went wrong ...
    </Typography>
  );
};

export default CheckFaultsFlow;
